export default __webpack_public_path__ + "static/hodl_vaults_dark-aaad034cf0cb55b891e050100281b4d6.png";